
import Alert from '@/components/elements/Alert.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'

export default {
  name: 'NothingArea',

  components: {
    Alert,
    HeadingLv3,
    HospitalCassette
  },

  props: {
    label: String,
    items: {
      type: Array,
      default: () => []
    }
  }
}
